// https://daneden.github.io/animate.css/

import { String } from '../String/String'

// !!! KELL a kiterjesztés is !!!

// Attention seekers
import './animatecss/attention_seekers/bounce.css'
import './animatecss/attention_seekers/heartBeat.css'
import './animatecss/attention_seekers/pulse.css'
import './animatecss/attention_seekers/rubberBand.css'
import './animatecss/attention_seekers/shake.css'
import './animatecss/attention_seekers/tada.css'
import './animatecss/attention_seekers/wobble.css'

// Bouncing entrances
import './animatecss/bouncing_entrances/bounceIn.css'
import './animatecss/bouncing_entrances/bounceInDown.css'
import './animatecss/bouncing_entrances/bounceInLeft.css'
import './animatecss/bouncing_entrances/bounceInRight.css'
import './animatecss/bouncing_entrances/bounceInUp.css'

// Bouncing exits
import './animatecss/bouncing_exits/bounceOut.css'
import './animatecss/bouncing_exits/bounceOutDown.css'
import './animatecss/bouncing_exits/bounceOutLeft.css'
import './animatecss/bouncing_exits/bounceOutRight.css'
import './animatecss/bouncing_exits/bounceOutUp.css'

// Fading entrances
import './animatecss/fading_entrances/fadeIn.css'
import './animatecss/fading_entrances/fadeInDown.css'
import './animatecss/fading_entrances/fadeInLeft.css'
import './animatecss/fading_entrances/fadeInRight.css'
import './animatecss/fading_entrances/fadeInUp.css'

// Fading exits
import './animatecss/fading_exits/fadeOut.css'
import './animatecss/fading_exits/fadeOutDown.css'
import './animatecss/fading_exits/fadeOutUp.css'
import './animatecss/fading_exits/fadeOutRight.css'

// Flash
import './animatecss/flash/flash.css'

// Flippers
import './animatecss/flippers/flipInX.css'
import './animatecss/flippers/flipInY.css'
import './animatecss/flippers/flipOutX.css'
import './animatecss/flippers/flipOutY.css'

// Rotating exits
import './animatecss/rotating_exits/rotateOut.css'

// Sliding
import './animatecss/sliding_exits/slideOutDown.css'
import './animatecss/sliding_exits/slideOutLeft.css'
import './animatecss/sliding_exits/slideOutRight.css'
import './animatecss/sliding_exits/slideOutUp.css'
import './animatecss/sliding_entrances/slideInDown.css'
import './animatecss/sliding_entrances/slideInLeft.css'
import './animatecss/sliding_entrances/slideInRight.css'
import './animatecss/sliding_entrances/slideInUp.css'

// Zoom
import './animatecss/zooming_exits/zoomOut.css'
import './animatecss/zooming_entrances/zoomIn.css'
import './animatecss/zooming_entrances/zoomInDown.css'
import './animatecss/zooming_entrances/zoomInLeft.css'
import './animatecss/zooming_entrances/zoomInRight.css'

const ANIMATION_TYPES = [
  'bounce',
  'bounceIn',
  'bounceInDown',
  'bounceInLeft',
  'bounceInRight',
  'bounceInUp',
  'bounceOut',
  'bounceOutDown',
  'bounceOutLeft',
  'bounceOutRight',
  'bounceOutUp',
  'fadeIn',
  'fadeInDown',
  'fadeInUp',
  'fadeInLeft',
  'fadeInRight',
  'fadeOut',
  'fadeOutDown',
  'fadeOutUp',
  'fadeOutRight',
  'flash',
  'flipInX',
  'flipInY',
  'flipOutX',
  'flipOutY',
  'heartBeat',
  'pulse',
  'rubberBand',
  'rotateOut',
  'shake',
  'slideInUp',
  'slideOutUp',
  'slideOutDown',
  'slideOutLeft',
  'slideOutRight',
  'slideInDown',
  'slideInLeft',
  'slideInRight',
  'tada',
  'wobble',
  'zoomIn',
  'zoomInDown',
  'zoomInLeft',
  'zoomInRight',
  'zoomOut'
] as const

export type TAnimType = typeof ANIMATION_TYPES[number]
type TAnimKey = Capitalize<TAnimType>

export type TAnim = Record<TAnimKey, TAnimType>

export const ANIMATIONS: TAnim = ANIMATION_TYPES.reduce((acc, curr) => {
  const key = String.ucFirst(curr)

  acc[key] = curr

  return acc
}, {} as TAnim)
